import { userConstants } from '../_constants';

let user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
	switch (action.type) {
		case userConstants.LOGIN_REQUEST:
			return {
				loggingIn: true,
				user: action.user
			};
		case userConstants.LOGIN_SUCCESS:
			return {
				loggedIn: true,
				user: action.user
			};
		case userConstants.LOGIN_FAILURE:
			return {};
		case userConstants.RESETPASSWORD_REQUEST:
			return {
				sending: true,
				email: action.email
			};
		case userConstants.RESETPASSWORD_SUCCESS:
			return {
				sent: true,
				message: action.response.message
			};
		case userConstants.RESETPASSWORD_FAILURE:
			return {};
		case userConstants.SETPASSWORD_REQUEST:
			return {
				loading: true,
			};
		case userConstants.SETPASSWORD_SUCCESS:
			return {
				message: action.response.message
			};
		case userConstants.SETPASSWORD_FAILURE:
			return {};
		case userConstants.LOGOUT:
			return {};
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/_reducers/authentication.reducer.js